import { request } from "./http-client.js"
const recipeApi = {
    getRecipeDetails(recipeId) {
        return request.get(`api/recipe/${recipeId}`);
    },
    getCommunityPosts(recipeId) {
        return request.get(`api/recipe/${recipeId}/posts`);
    },
    getComments(recipeId) {
        return request.get(`api/recipe/${recipeId}/comments`);
    }
}
export default recipeApi